import React from 'react';

interface IconThinkingBrainProps {
  className?: string;
  size?: number;
}

export const IconThinkingBrain: React.FC<IconThinkingBrainProps> = ({ className = '', size = 167 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 167 167"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.69393" filter="url(#filter0_f_thinking_brain)">
        <path
          d="M35.8999 83.1691C35.8999 57.0622 57.0637 35.8984 83.1705 35.8984C109.277 35.8984 130.441 57.0622 130.441 83.1691C130.441 109.276 109.277 130.44 83.1705 130.44C57.0637 130.44 35.8999 109.276 35.8999 83.1691Z"
          fill="#4236FF"
          fillOpacity="0.4"
        />
      </g>
      <path
        d="M63.1707 48.5312C82.3025 37.4856 106.766 44.0406 117.812 63.1723C128.857 82.304 122.302 106.768 103.171 117.813C84.039 128.859 59.5754 122.304 48.5297 103.172C37.484 84.0406 44.039 59.5769 63.1707 48.5312Z"
        fill="url(#paint0_linear_thinking_brain)"
      />
      <g clipPath="url(#clip0_thinking_brain)">
        <path
          d="M74.0775 88.4219L93.7795 77.0469"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.2801 88.5933C83.9064 87.0607 84.0393 85.4483 84.6589 83.9977C85.2786 82.547 86.3516 81.3362 87.7173 80.5466C86.3507 81.3345 84.7656 81.6584 83.1994 81.4697C81.6333 81.281 80.1705 80.59 79.0301 79.5"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.4045 86.843C97.2098 86.8431 98.0043 86.6578 98.7266 86.3017C99.4489 85.9455 100.08 85.428 100.57 84.7891C101.06 84.1503 101.397 83.4072 101.554 82.6173C101.711 81.8275 101.684 81.0121 101.476 80.2342C101.267 79.4564 100.883 78.7369 100.352 78.1314C99.8209 77.526 99.1578 77.0508 98.4138 76.7426C97.6698 76.4345 96.8648 76.3016 96.0612 76.3543C95.2577 76.407 94.477 76.6438 93.7796 77.0465C94.477 76.6439 95.0725 76.0862 95.5199 75.4166C95.9673 74.7471 96.2547 73.9835 96.3599 73.1851C96.465 72.3867 96.385 71.5748 96.1262 70.8122C95.8673 70.0497 95.4365 69.3569 94.8671 68.7874C94.2976 68.218 93.6048 67.7872 92.8423 67.5284C92.0797 67.2695 91.2678 67.1896 90.4694 67.2947C89.671 67.3998 88.9074 67.6872 88.2379 68.1347C87.5683 68.5821 87.0106 69.1776 86.608 69.875"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M98.8374 86.2422C99.1227 87.2653 99.1714 88.3398 98.9799 89.3845C98.7884 90.4292 98.3616 91.4167 97.732 92.272C97.1024 93.1274 96.2863 93.8282 95.3457 94.3215C94.4051 94.8148 93.3646 95.0876 92.303 95.1192"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M79.3274 97.5154C80.0979 98.8498 81.2871 99.8927 82.7108 100.482C84.1344 101.072 85.7127 101.175 87.2011 100.777C88.6895 100.378 90.0047 99.499 90.9428 98.2766C91.8808 97.0541 92.3893 95.5563 92.3894 94.0155"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M81.832 100.042C81.0715 100.623 80.2001 101.042 79.2715 101.272C78.3429 101.503 77.3769 101.541 76.4331 101.384C75.4893 101.226 74.5878 100.877 73.7842 100.358C72.9806 99.8386 72.292 99.16 71.761 98.3641C71.2299 97.5682 70.8676 96.6719 70.6966 95.7305C70.5255 94.7891 70.5492 93.8227 70.7663 92.8908C70.9834 91.959 71.3892 91.0815 71.9587 90.3126C72.5281 89.5437 73.2492 88.8998 74.0773 88.4205C73.2482 88.898 72.3299 89.2005 71.3793 89.3092C70.4287 89.418 69.4659 89.3307 68.5504 89.0527C67.6348 88.7748 66.786 88.3121 66.0562 87.6933C65.3265 87.0744 64.7314 86.3125 64.3077 85.4547C63.8839 84.5968 63.6406 83.6612 63.5926 82.7056C63.5446 81.75 63.693 80.7947 64.0287 79.8987C64.3644 79.0027 64.8802 78.185 65.5443 77.4962C66.2084 76.8074 67.0066 76.262 67.8897 75.8938"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.8275 79.3273C68.0571 77.9928 67.7486 76.4414 67.9497 74.9137C68.1509 73.386 68.8505 71.9674 69.94 70.8778C71.0296 69.7883 72.4482 69.0886 73.9759 68.8875C75.5036 68.6863 77.055 68.9948 78.3895 69.7652"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.3425 68.0682C87.5992 67.3096 86.6929 66.7301 85.6924 66.3736C84.6919 66.0171 83.6234 65.893 82.5678 66.0106C81.5123 66.1282 80.4973 66.4845 79.5998 67.0524C78.7023 67.6203 77.9458 68.3851 77.3876 69.2887"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_thinking_brain"
          x="-9.91821e-05"
          y="-0.00156403"
          width="166.341"
          height="166.343"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="17.95" result="effect1_foregroundBlur_thinking_brain" />
        </filter>
        <linearGradient
          id="paint0_linear_thinking_brain"
          x1="97.8118"
          y1="28.5312"
          x2="68.5297"
          y2="137.813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#725CFF" />
          <stop offset="1" stopColor="#E93FFF" />
        </linearGradient>
        <clipPath id="clip0_thinking_brain">
          <rect width="42" height="42" fill="white" transform="translate(90.8572 54.4844) rotate(60)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconThinkingBrain;
